import { DotLottieWorkerReact } from '@lottiefiles/dotlottie-react'

import { CloseIcon, useStarAnim } from '@shared'
import { useOverlayActions } from '@store'

import styles from './SoonOverlay.module.scss'
import { Light, Rectangle, Vector } from './img'

export const SoonOverlay = () => {
  const { hideOverlay } = useOverlayActions()
  const { starAnim } = useStarAnim()
  return (
    <div className={styles.soonContainer} onClick={hideOverlay}>
      <div className={styles.contentContainer}>
        <CloseIcon className={styles.closeIcon} />
        <span className={styles.soonText}>Soon</span>
        <Rectangle variant="left" className={styles.imgLeft} />
        <Rectangle variant="right" className={styles.imgRight} />
        <Light className={styles.img} />
        <Vector className={styles.img} />
        <DotLottieWorkerReact
          data={starAnim}
          autoplay
          loop
          className={styles.stars}
        />
      </div>
    </div>
  )
}
